class StoreKeys {
    static get CurrentUser() { return "currentUser" }
    static get LoginLocked() { return "loginLocked" }
    static get DataChanged() { return "dataChanged" }
}

class SysMessages {
    static get RecordSaved() { return "Record saved successfully." }
    static get RecordDeleted() { return "Record deleted successfully." }
    static get OperationError() { return "Error in performing operation. Check system logs for more details" }
    static get Unauthorized() { return "You are not authorized to perform this action." }
    static get BadGateway() { return "Error connecting to server. Please check your internet connection." }
    static get NotFound() { return "Not Found. The resource you requested can not be found." }
    static get NotAllowed() { return "Error connecting to server. Please check your internet connection." }
}


class SignalEvents {
    static get InterestProcess() { return "InterestProcess" }
}

class Routes {
    static get Login() { return "login" }
    static get UnAuthorized() { return "unauthorized" }
    static get Dashboard() { return "dashboard" }
    static get Members() { return "members" }
    static get MemberAccount() { return "memberaccount" }
    static get Transactions() { return "transactions" }
    static get Investments() { return "investments" }
    static get Investment() { return "investment" }
    static get TransactionForm() { return "transaction" }
    static get Reports() { return "reports" }
    static get ReportViewer() { return "reportViewer" }
    static get Settings() { return "settings" }
    static get DataUploads() { return "settings.datauploads" }
    static get GenericSettings() { return "settings.lookup" }
    static get Admin() { return "admin" }
    static get Users() { return "admin.users" }
    static get Roles() { return "admin.roles" }
    static get ChangePassword() { return "changePassword" }
}

class PartialViews {
    static get UserForm() { return "user_form" }
    static get RoleForm() { return "role_form" }
    static get DocumentViewer() { return "doc_viewer" }
    static get MemberForm() { return "member_form" }
    static get TransactionForm() { return "transaction_form" }
    static get InvestmentForm() { return "investment_form" }
    static get MemberMonthlyInterest() { return "monthly_interest" }
}

class AppServices {
    static get BaseApi() { return "BASEAPI" }
    static get AuthService() { return "AuthService" }
    static get RequestInterceptor() { return "RequestInterceptor" }
    static get MemberService() { return "MemberService" }
    static get InvestmentService() { return "InvestmentService" }
    static get TransactionService() { return "TransactionService" }
    static get UserService() { return "UserService" }
    static get RoleService() { return "RoleService" }
    static get ReportsConfig() { return "ReportsConfig" }
    static get ReportService() { return "ReportService" }
    static get LookUpService() { return "LookUpService" }
    static get DataAdapter() { return "DataAdapter" }
    static get StatsService() { return "StatsService" }
}

interface IDataAdapter {
    get(model: string): angular.IPromise<any>
    reload(): void
    store(name: string, item: Object): void
    retrieve(name: string): any
}

class AngularServices {
    static get Q() { return "$q" }
    static get Http() { return "$http" }
    static get State() { return "$state" }
    static get StateParams() { return "$stateParams" }
    static get UibModal() { return "$uibModal" }
    static get Scope() { return "$scope" }
    static get RootScope() { return "$rootScope" }
    static get UibModalInstance() { return "$uibModalInstance" }
    static get Location() { return "$location" }
    static get HotKeys() { return "hotkeys" }
}

class AppControllers {
    static get LoginCtrl() { return 'LoginCtrl' }
    static get UserProfileCtrl() { return 'UserProfileCtrl' }
    static get MainCtrl() { return 'MainCtrl' }
    static get DashboardCtrl() { return 'DashboardCtrl' }
    /* Members */
    static get MemberCtrl() { return 'MemberCtrl' }
    static get MemberAccountCtrl() { return 'MemberAccountCtrl' }
    /* Transactions */
    static get TransactionCtrl() { return 'TransactionCtrl' }
    static get TransactionFormCtrl() { return 'TransactionFormCtrl' }
    /* Investments */
    static get InvestmentsCtrl() { return 'InvestmentsCtrl' }
    static get InvestmentCtrl() { return 'InvestmentCtrl' }
    static get MemberMonthlyInterestCtrl() { return 'MemberMonthlyInterestCtrl' }

    /* Settings */
    static get SettingsCtrl() { return 'SettingsCtrl' }
    static get SettingCtrl() { return 'SettingCtrl' }
    /* User Roles */
    static get UsersCtrl() { return 'UsersCtrl' }
    static get RolesCtrl() { return 'RolesCtrl' }
    /* Reports */
    static get DocumentViewerCtrl() { return 'DocumentViewerCtrl' }
    static get ReportsCtrl() { return 'ReportsCtrl' }
    static get ReportViewerCtrl() { return 'ReportViewerCtrl' }
    static get PreviewerCtrl() { return 'PreviewerCtrl' }
    /* Upload */
    static get DataUploadCtrl() { return "DataUploadCtrl" }
}
export { StoreKeys, SysMessages, Routes, PartialViews, AppServices, AngularServices, AppControllers, IDataAdapter, SignalEvents }


// WEBPACK FOOTER //
// ./app/helpers/config_keys.ts